import { Component } from "preact";

import { connect } from "react-redux";
import { css } from "emotion";
import Pills from "./pills";
import { setRefinements } from "../../../state/actions/searchActions";

class PillHandler extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { search = {}, setRefinements } = this.props;
    const { searchComponent = {} } = search;
    const { categories, accessibility, date, tags, hideTags } = searchComponent;
    const wrapper = css({
      marginBottom:
        categories.length ||
        accessibility.length ||
        (date && date.refinement !== "All")
          ? 32
          : 0
    });
    return (
      <div className={wrapper}>
        {categories.map(c => (
          <Pills
            type="close"
            name={c}
            clearRefinement={() =>
              setRefinements({ categories: categories.filter(v => v !== c) })
            }
          />
        ))}
        {accessibility.map(c => (
          <Pills
            type="close"
            name={c}
            clearRefinement={() =>
              setRefinements({
                accessibility: accessibility.filter(v => v !== c)
              })
            }
          />
        ))}
        {hideTags !== true
          ? tags.map(c => (
              <Pills
                type="close"
                name={c.name}
                clearRefinement={() =>
                  setRefinements({ tags: tags.filter(v => v !== c) })
                }
              />
            ))
          : null}
        {date && date.refinement !== "All" ? (
          <Pills
            type="close"
            name={date.pillInformation}
            clearRefinement={() => setRefinements({ date: null })}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    search: state.search
  }),
  {
    setRefinements
  }
)(PillHandler);
